import 'core-js/es6/map';
import 'core-js/es6/set';
import React, { Component } from 'react';
import {sify,tify} from 'chinese-conv';
import {FormattedMessage, intlShape ,injectIntl } from 'react-intl';
import {Button,Alert,Row,Col,Input,Collapse,InputGroup,FormGroup } from 'reactstrap';
import  'bootstrap/dist/css/bootstrap.min.css';
import './Main.css';
import 'react-select/less/select.less';
import Select from 'react-select';


     class HeaderTitle extends React.Component {
        render() {
            return (
                <Row className="headerTitle">
                <Col md={4}>
                    <img src="logo_mpu.png"/>
                  </Col>
                  <Col md={8}>
                    <h3><FormattedMessage id='title' /></h3>
                  </Col>
                </Row>
            );
        }
      }
    class LanguageSwitcher extends React.Component {
        render() {
            return (
                <div className="lang">
                    <a href="?lang=en">English</a>|
                    <a href="?lang=mo">繁體</a>|
                    <a href="?lang=cn">简体</a>|
                    <a href="?lang=pt">Português</a>
                </div>
            );
        }
      }
    class PreInfo extends React.Component {
        render() {
            return (
                <Alert color="warning">
                    <FormattedMessage id='preMessage'/>
                </Alert>
            );
        }
      }
     class Loading extends React.Component {
        render() {
            return (
                <div>
                  <div className={"loaderModal "+ this.props.className}></div>
                  <div className={"loader " + this.props.className}></div>
                </div>
            );
        }
      }

     class FormRow extends Component {
      render(){
        return (
            <Row>
              <Col md={4}>
                <label>
                  <FormattedMessage id={this.props.labelId}/>
                </label>
              </Col>
              <Col md={8}>
                   {this.props.children}  
              </Col>          
            </Row>
          );
      }
    }
    class InputBox extends Component {
      constructor(){
          super();
          this.handleChange = this.handleChange.bind(this);
          this.state={
            value:""
          }
      }
       handleChange(e) {
        this.setState({ value: e.target.value });
      }
      render() {
        const intl = this.props.intl;
        let placeholder="";
        if(this.props.placeholderId){
            placeholder = intl.formatMessage({
                    id: this.props.placeholderId
            });
        }


        if(intl.locale==="zh-CN" && this.props.tctranslate){

          return (
            <FormGroup>
              <InputGroup>
                <Input id={this.props.name} disabled={this.props.disabled} type={this.props.type} name={this.props.name} onPropertyChange={this.props.onChange}
                        placeholder={placeholder} value={this.props.value} onChange={this.props.onChange} required={this.props.required?true:false}
                         />
                <span className="input-group-btn">
                  <TranslateBtn disabled={this.props.disabled} clickEvent={this.props.onTranslate}/>
                </span>
              </InputGroup>
              <div className="hints">{intl.formatMessage({id: "form.studName.hints"})}</div>
              <div className="invalid-feedback">
                <FormattedMessage id="form.error.required" />
              </div>
            </FormGroup>
            );  
          
        }
        else{
          return (
            <FormGroup>
              <Input id={this.props.name} disabled={this.props.disabled} min={this.props.min} max={this.props.max} type={this.props.type} name={this.props.name} placeholder={placeholder} required={this.props.required?true:false}/>
              <div className="invalid-feedback">
                <FormattedMessage id="form.error.required" />
              </div>
            </FormGroup>
            );
        }
        
      }
    }
    InputBox.propTypes = {
        intl: intlShape.isRequired
    };
    InputBox = injectIntl(InputBox);

    class RadioButtonGroup extends Component {

      render() {

        const childrenButton = React.Children.map(this.props.children, (child,index) => {
              if(child.props.labelId){
                return (
                        <div>
                          <input disabled={this.props.disabled} type="radio" id={this.props.name+(index+1)} name={this.props.name} className="custom-control-input form-check-input" value={child.props.value} required={this.props.required?true:false} onClick={child.props.clickEvent}/>
                          <label className="custom-control-label" htmlFor={this.props.name+(index+1)}>
                            <FormattedMessage id={child.props.labelId} />
                          </label>
                        </div>
                );
              }
              else{
                 return (
                        <div>
                          <input disabled={this.props.disabled} type="radio" id={this.props.name+(index+1)} name={this.props.name} className="custom-control-input form-check-input" value={child.props.value} required={this.props.required?true:false} onClick={child.props.clickEvent}/>
                          <label className="custom-control-label" htmlFor={this.props.name+(index+1)}>
                            {child.props.label}
                          </label>
                        </div>
                );
              }
            });

        return (
              <FormGroup>
                <div className="form-check">
                <div className="custom-control custom-radio">
                        {childrenButton}

                </div>
                <div className={this.props.validation}>
                  <FormattedMessage id="form.error.radio.required" />
                </div>
                </div>
              </FormGroup>
        );
      }
    }

      class CheckResult extends React.Component {
        render() {
            if(this.props.result==="success"){
              return (
              <Row>
                <Col md="12">
                  <div className={this.props.className}>
                    <Alert color="success">
                      <h5><FormattedMessage id='result.title'/></h5>
                      <FormattedMessage id='result.success'/>
                    </Alert>
                  </div>
                </Col>
              </Row>
              );
            }
            else if(this.props.result==="fail"){
              return (
              <Row>
                <Col md="12">
                  <div className={this.props.className}>
                    <Alert color="danger">
                        <h5><FormattedMessage id='result.title'/></h5>
                        <FormattedMessage id='result.fail'/>
                    </Alert>
                  </div>
                </Col>
              </Row>
              );
            }
            else if(this.props.result==="error"){
              return (
              <Row>
                <Col md="12">
                  <div className={this.props.className}>
                    <Alert color="danger">
                        <h5><FormattedMessage id='server.error'/></h5>
                    </Alert>
                  </div>
                </Col>
              </Row>
              );
            }
            return (<div></div>);

        }
      }



      class TranslateBtn extends React.Component {
        render() {
            return (
                <Button disabled={this.props.disabled} color="info" onClick={this.props.clickEvent}><FormattedMessage id='convertTC'/></Button>
            );
         }
      }

    class CheckForm extends React.Component {
        

        constructor(props){
            super(props);
            this.state = {
              studName:"",
              gradYearOpen: false,
              programOpen: false,
              qualOpen:false,
              formvalidation:"",
              statusRadioValidation:"invalid-feedback",
              qualRadioValidation:"invalid-feedback",
              progRadioValidation:"invalid-feedback",
              progRadioValidationBox:"",
              checkStatus:"",
              levelOptions:[],
              programOpt:[],
              programVal:"",
              programLoading:false,
              token:"",
              loading:false,
              serviceURL:"qvsService.ashx",
              //serviceURL:"http://localhost:5735/qvsService.ashx",
              submitButHide:"",
            };
            this.handleSubmit = this.handleSubmit.bind(this);
            this.handleReset = this.handleReset.bind(this);
            this.handleStateClick = this.handleStateClick.bind(this);
            this.handleQualClick = this.handleQualClick.bind(this);
            this.handleProgChange = this.handleProgChange.bind(this);
            this.handleStudNameChange=this.handleStudNameChange.bind(this);
            this.handleStudNameTranslate = this.handleStudNameTranslate.bind(this);
            this.handleModify = this.handleModify.bind(this);
            
        }

        scrollToBottom = () => {
          this.messagesEnd.scrollIntoView({ behavior: "smooth" });
        }
        componentDidMount(){
          const csrf = document.getElementById("mt");
          this.setState({token:csrf.value});
          
          /*var data= {"service":"level","token":csrf.value};

          fetch(this.state.serviceURL
            ,{
                method:'POST',
                headers: {
                  'content-type': 'application/json'
                  
                },
                body:JSON.stringify(data),
                'credentials': 'same-origin'
                
              }
            ).then((response) =>{
              if(response.status===200) 
                return response.json(); 
              else  
               this.setState({checkStatus:"error",submitButHide:"submitBtnHide"});
            })
            .then((json) => {
              if(json)
              for(var i=0;i<json.levels.length;i++){
                json.levels[i]["level_cn"]=sify(json.levels[i]["level_mo"]);
                var tmpstate = this.state.levelOptions;
                tmpstate.push(json.levels[i]);
                this.setState({levelOptions: tmpstate});
              }

          });*/

        }
        handleStateClick(event){
          if(event.target.value==="E")
            this.setState({ statusRadioValidation:"invalid-feedback",gradYearOpen: false });
          else
            this.setState({ statusRadioValidation:"invalid-feedback",gradYearOpen: true });

            const intl = this.props.intl;
            const tform = document.getElementById("checkForm");
            var tstate = "",tqual="";

            for(var i=0;i<tform.elements.status.length;i++){
                  if(tform.elements.status[i].checked)
                    tstate= tform.elements.status[i].value;
              }

              if(tstate.length===0){
                return;
              }

              var data= {"service":"level","status":tstate,"token":this.state.token};
              fetch(this.state.serviceURL
                    ,{
                        method:'POST',
                        headers: {
                          'content-type': 'application/json'
                        },
                        body:JSON.stringify(data),
                        'credentials': 'same-origin'
                      }
                    ).then((response) =>{
                      if(response.status===200) 
                        return response.json(); 
                      else  
                       this.setState({checkStatus:"error",submitButHide:"submitBtnHide"});
                    })
                    .then((json) => {
                      if(json){
                        this.setState({levelOptions:[]});
                        //this.state.levelOptions=[];
                        for(var i=0;i<json.levels.length;i++){
                          json.levels[i]["level_cn"]=sify(json.levels[i]["level_mo"]);
                          var tmpstate = this.state.levelOptions;
                          tmpstate.push(json.levels[i]);
                          this.setState({levelOptions: tmpstate});
                        }
                        this.setState({qualOpen:true,programOpen:false});

                      }
                  });
          //this.handleQualClick();
        }
        handleStudNameChange(e) {
          this.setState({ studName: e.target.value });
        }
        handleStudNameTranslate(){
           const tform = document.getElementById("checkForm");
           this.setState({ studName: tify(tform.elements.studName.value) });
          /*if(typeof this.state.studName !== "undefined"){
           this.setState({ studName: tify(this.state.studName) });
          }*/
        }
        handleModify(event) {
          this.setState({
                        submitButHide:"",
                        checkStatus:"",
                        progRadioValidationBox:"validSelectControlBox"
                        });

        }
        handleReset(event) {
          this.setState({checkStatus:"",
                        submitButHide:"",
                        programVal:"",
                        statusRadioValidation:"invalid-feedback",
                        qualRadioValidation:"invalid-feedback",
                        progRadioValidation:"invalid-feedback",
                        dobValidation:"invalid-feedback",
                        gradYearValidation:"invalid-feedback",
                        progRadioValidationBox:"",
                        formvalidation:"",
                        gradYearOpen:false,
                        programOpen:false,
                        qualOpen:false,
                        studName:""
                        });

        }

        handleSubmit(event) {
            const intl = this.props.intl;
            let allvalid = true;
            event.preventDefault();
            this.setState({formvalidation:"was-validated"});

            const tform = document.getElementById("checkForm");
            //const data = new FormData(tform);
            var tstate = "",tqual="";
            for(var i=0;i<tform.elements.status.length;i++){
                if(tform.elements.status[i].checked)
                  tstate= tform.elements.status[i].value;
            }
            for(var j=0;j<tform.elements.qual.length;j++){
                if(tform.elements.qual[j].checked)
                  tqual= tform.elements.qual[j].value;
            }
            if(tqual.length==0 && typeof tform.elements.qual!=="undefined"){
              if(tform.elements.qual.checked)
                  tqual= tform.elements.qual.value;
            }

            if(tstate==="C" && tform.elements.dob.value.length<10 && !isNaN(new Date(tform.elements.dob.value)) ){
              var d=new Date(tform.elements.dob.value);
              var mm = d.getMonth() + 1; // getMonth() is zero-based
              var dd = d.getDate();
              tform.elements.dob.value = [d.getFullYear(),(mm>9 ? '' : '0') + mm,(dd>9 ? '' : '0') + dd].join('/');
            }

            if(tstate==="C" && tform.elements.gradYear.value.length>0 && isNaN(parseInt(tform.elements.gradYear.value)) ){
              tform.elements.gradYear.value="";
            }

            var data = {"status":  tstate,
                    "studName":tform.elements.studName.value,
                    "dob":tform.elements.dob.value,
                    "gradYear":tform.elements.gradYear.value,
                    "qual"  :tqual,
                    "prog"  :tform.elements.prog.value,
                    "certNo" : tform.elements.certNo.value,
                    "service": "verify",
                    "lang":intl.locale,
                    "token":this.state.token
                    };
            if(tstate.length===0){
              this.setState({statusRadioValidation:"invalidatedRadio"});
            }
            if(tqual.length===0){
              this.setState({qualRadioValidation:"invalidatedRadio"});

            }

            if(!tform.elements.prog.value|| tform.elements.prog.value.length===0){
              this.setState({progRadioValidation:"invalidSelectControl",progRadioValidationBox:"invalidSelectControlBox"});
            }


            if(tstate.length===0 || tform.elements.studName.value.length===0  || tform.elements.prog.value.length===0 || tform.elements.certNo.value.length===0 || tqual.length===0 || 
              (tstate==="C" && (tform.elements.dob.value.length===0 || tform.elements.gradYear.value.length===0 ) ) ){
              allvalid = false;
            }
            if(allvalid){
               this.setState({loading:true});
               this.scrollToBottom();
              fetch(this.state.serviceURL, {
                method: 'POST',
                headers: {
                  'content-type': 'application/json'
                  
                },
                body:JSON.stringify(data),
                'credentials': 'same-origin'
                
              })
              .then((response) => {
                      if(response.status===200) 
                        return response.json(); 
                      else  
                        this.setState({checkStatus:"error",submitButHide:"submitBtnHide"});
                      this.setState({loading:false});
                    })
              .then((json) => {
                if(json)
                  this.setState({checkStatus:json.status,submitButHide:"submitBtnHide",progRadioValidation:"invalid-feedback",progRadioValidationBox:""});
                this.setState({loading:false});
              });;
            }

            return false;
          }
        handleProgChange(value) {

            if(value){
              this.setState({
                programVal: value,
                progRadioValidation:"invalid-feedback",
                progRadioValidationBox:"validSelectControlBox"
              });
            }
            else if(this.state.formvalidation==="was-validated"){
              this.setState({
                programVal: "",
                progRadioValidation:"invalidSelectControl",
                progRadioValidationBox:"invalidSelectControlBox"
              });
            }
            else if(this.state.formvalidation===""){
               this.setState({programVal: "",progRadioValidation:"invalid-feedback",progRadioValidationBox:""});
            }
          }
        handleQualClick(event){
          const intl = this.props.intl;
          const tform = document.getElementById("checkForm");
          var tstate = "",tqual="";
          for(var i=0;i<tform.elements.status.length;i++){
                  if(tform.elements.status[i].checked)
                    tstate= tform.elements.status[i].value;
          }
          for(var j=0;j<tform.elements.qual.length;j++){
                    if(tform.elements.qual[j].checked)
                      tqual= tform.elements.qual[j].value;
          }

          if(tqual.length==0 && typeof tform.elements.qual!=="undefined")
          {
            tqual=tform.elements.qual.value;
          }
          
          if(tstate.length>0 && tqual.length>0)
          {
             var data = {"service":"program","status":tstate,"level":tqual,"lang":intl.locale,"token":this.state.token};

             this.setState({programLoading:true});
             fetch(this.state.serviceURL
             ,{
                 method:'POST',
                 headers: {
                 'content-type': 'application/json'
                 },
                 body:JSON.stringify(data),
                'credentials': 'same-origin'
              }
             )
             .then((response) => {
                  if(response.status===200) 
                    return response.json(); 
                  else  
                    this.setState({checkStatus:"error",submitButHide:"submitBtnHide"});

                })
             .then((json) => {
                  if(!json)
                    return;
                  if(intl.locale==="zh-CN"){
                    for(var i=0;i<json.programs.length;i++){
                      json.programs[i]["program_name"]=sify(json.programs[i]["program_name"]);
                    }
                  }
                  this.setState({programOpt:json.programs,programVal:"",
                                programOpen:true,qualRadioValidation:"invalid-feedback",
                                programLoading:false});

                  if(this.state.progRadioValidationBox!==""){
                    this.setState({progRadioValidation:"invalidSelectControl",
                                progRadioValidationBox:"invalidSelectControlBox"});
                  }

                });
            }
        }
        /*handleQualClick(event){
          }*/
        render() {
            return (
                <form id="checkForm" className={'needs-validation '+this.state.formvalidation} noValidate>
                    <div>
                      <FormRow labelId="form.status">
                          <RadioButtonGroup disabled={this.state.submitButHide===""?false:true} name="status" required color="secondary" validation={this.state.statusRadioValidation}>
                              <option value="E"  labelId="form.status.current" clickEvent={this.handleStateClick}/>
                              <option value="C"  labelId="form.status.graduate" clickEvent={this.handleStateClick}/>
                          </RadioButtonGroup>
                      </FormRow>
                      <hr/>
                      <FormRow labelId="form.studName">
                          <InputBox type="text" value={this.state.studName} onChange={this.handleStudNameChange} onTranslate={this.handleStudNameTranslate} disabled={this.state.submitButHide===""?false:true} placeholderId="form.studName.placeholder" name="studName" tctranslate required/>
                      </FormRow>
                      <Collapse isOpen={this.state.gradYearOpen}>
                        <FormRow labelId="form.dob">
                            <InputBox type="text" disabled={this.state.submitButHide===""?false:true} placeholderId="form.dob.placeholder" name="dob" validationState={null} required/> 

                        </FormRow>
                      </Collapse>
                      <Collapse isOpen={this.state.gradYearOpen}>
                              <FormRow labelId="form.gradYear">
                                  <InputBox type="number" disabled={this.state.submitButHide===""?false:true} placeholderId="form.gradYear.placeholder" name="gradYear" validationState={null} required={this.state.gradYearOpen?true:false}/> 
                              </FormRow>
                      </Collapse>
                      <Collapse isOpen={this.state.qualOpen}>
                        <FormRow labelId="form.qual">
                            <RadioButtonGroup name="qual" disabled={this.state.submitButHide===""?false:true} required color="secondary" validation={this.state.qualRadioValidation}>
                              {(this.state.levelOptions).map((option,index)=>
                                <option  value={option["code"]} key={"qual"+option["code"]} label={option["level_"+this.props.intl.locale.toLowerCase().split('-')[1]]} clickEvent={this.handleQualClick}/>
                              )}
                            </RadioButtonGroup>
                        </FormRow>
                      </Collapse>
                      <Collapse isOpen={this.state.programOpen}>
                        <FormRow labelId="form.prog">
                            <div className="section">
                              <Select valueKey="code" 
                                    required={true}
                                    name="progS"
                                    labelKey={"program_name"} 
                                    className={this.state.progRadioValidationBox}
                                    options={this.state.programOpt} 
                                    onChange={this.handleProgChange}
                                    value={this.state.programVal}
                                    isLoading={this.state.programLoading}
                                    disabled={this.state.submitButHide===""?false:true}
                              />
                              <input type="hidden" name="prog" value={this.state.programVal?this.state.programVal["code"]:""}/>
                              <div className={this.state.progRadioValidation}>
                                <FormattedMessage id="form.error.required" />
                              </div>
                            </div>

                        </FormRow>
                      </Collapse>
                      <FormRow labelId="form.certNo">
                          <InputBox type="text" name="certNo" disabled={this.state.submitButHide===""?false:true} required/> 
                      </FormRow>
                      <div className="hints"><FormattedMessage id='form.hints'/></div>
                    </div>
                    <input type="hidden" name="token" value={this.state.token}/>
                    <Button onClick={this.handleSubmit} color="primary" outline type="submit" className={"submitBtn " +this.state.submitButHide}><FormattedMessage id='form.submit'/></Button>
                    <Button onClick={this.handleModify} color="success" outline className={"submitBtn "+((this.state.submitButHide==="" || this.state.checkStatus==="error")?"submitBtnHide":"")}><FormattedMessage id='form.modify'/></Button>
                    <Button onClick={this.handleReset} color="danger" outline type="reset" className={"submitBtn "+(this.state.checkStatus==="error"?"submitBtnHide":"")} ><FormattedMessage id="form.reset"/></Button>
                    <CheckResult className="resultAlert" result={this.state.checkStatus} />
                    <Loading className={(this.state.loading?"loaderShow":"")}/>
                    <div style={{ float:"left", clear: "both" }} ref={(el) => { this.messagesEnd = el; }}></div>
                </form>

            );
        }
      }
	  
    CheckForm.propTypes = {
        intl: intlShape.isRequired
    };
    CheckForm = injectIntl(CheckForm);

	  class Main extends React.Component {
      constructor(){
        super();
        this.state={
          
        }
      }

  		render() {
  		return (
  			<div className="container">
  				<HeaderTitle />
  				<LanguageSwitcher />
  				<PreInfo />
  				<CheckForm />
  						
  			</div>
  		  );
  	  }
	}
	  
	  export default Main;


// WEBPACK FOOTER //
// ./src/Main.js